import styled from 'styled-components';

import LoadingOverlay from 'web-app/react/components/loading/loading-overlay/loading-overlay';

export const StyledLoadingOverlay = styled(LoadingOverlay)`
    height: 100%;
`;
